export default __webpack_public_path__ + "static/media/3.2de59013.svg";